// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"d303483f","223":"1b54e3c2","321":"229bff63","433":"85e78449","573":"cc373e27","830":"f5764779"}[chunkId] + ".chunk.js";
};